import { Injectable, OnInit } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient, HttpBackend } from '@angular/common/http';
import { Utenteservice } from './utente.service';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { alert } from "devextreme/ui/dialog"
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class Apiservice implements OnInit {

  public href: string = "";
  httpClientNoInterceptor: any;
  public errore500: boolean = false;



  constructor(private loc: Location, private utenteService: Utenteservice, private router: Router, private spinner: NgxSpinnerService, private httpClientBack: HttpBackend, private httpClient: HttpClient, private userservice: Utenteservice) {
    this.httpClientNoInterceptor = new HttpClient(httpClientBack)

  }

  ngOnInit() {
    this.href = this.router.url;
    //console.log("SERVER NAME ",this.loc.path());
    //console.log(this.router.url);
  }

  public httpOptionCall(contentType: 'application/json' | 'application/x-www-form-urlencoded' | 'text/plain' | 'multipart/form-data' = 'application/json') {
    let httpOptions = {
      headers: new HttpHeaders()
        .set("Authorization", 'Bearer ' + this.userservice.DammiToken())
        .set('Content-Type', `${contentType}; charset=UTF-8`),
      params: new HttpParams()
    };
    // httpOptions.headers.append("Authorization", 'Bearer '+this.userservice.DammiToken());
    //alert(this.userservice.DammiToken());
    // console.log("Token "+this.userservice.DammiToken());
    return httpOptions;
  }
  public HeaderOdata(contentType: 'application/json' | 'application/x-www-form-urlencoded' | 'text/plain' | 'multipart/form-data' = 'application/json') {
    const headers = new HttpHeaders().set("Authorization", 'bearer ' + this.userservice.DammiToken())
      .set('Content-Type', `${contentType}; charset=UTF-8`);
    return headers;
  }
  public parseHttpEvt(HttpEvt) {
    if (HttpEvt['body']['codeMessage'] == -2 && HttpEvt['body']['stato'] != -6) {
      alert(HttpEvt['body']['descrMessage'], 'Informazione')
    }
    console.log("PARSE ", HttpEvt)
  }
  public parseHttpErrorResponse(HttpErrorResponse: any) {
    let message = (HttpErrorResponse.statusText) ? HttpErrorResponse.statusText : '';
    if (message = "OK") message = "";

    if (HttpErrorResponse.status == '0' || HttpErrorResponse.status == '500') {
      if (this.errore500 == true) return ''; else this.errore500 = true;
    }
    if (HttpErrorResponse.status == '401') {
      if (this.errore500 == true) return ''; else {
        this.errore500 = true;

      }
    }
    if (HttpErrorResponse.status == '404') {
      if (HttpErrorResponse.error) message += "<br>" + "<p style='text-align:center'>" + HttpErrorResponse.error.descrMessage + "</p>"
      else message = "<p style='font-size:36px;color:red'><strong>404</strong><p>" + HttpErrorResponse.message
      /*if(HttpErrorResponse.error != null ) { //  HttpErrorResponse.error.descrMessage
          message="<p style='font-size:36px;color:red'><strong>404</strong><p>"+HttpErrorResponse.error.descrMessage;      
      }else{          
          let value='<ul>';
          for (let key in HttpErrorResponse.error.errors) {
            value+="<li> <p><strong>"+key+"</strong>&nbsp"+HttpErrorResponse.error.errors[key]+"</p></li>";
          }
          value+='</ul>';
          message=value;      
        }*/

    }
    if (HttpErrorResponse.status == '500') {
      message = "<p style='font-size:24px;color:red;'>" + "Errore Interno del Server" + "</p>";
      //if(HttpErrorResponse.error) message+="<br>"+HttpErrorResponse.error.descrMessage  

    }
    if (HttpErrorResponse.status == '401') {
      // if(this.utenteService.checSessionError==true) return message;else this.utenteService.checSessionError=true
      message = "";//"<p style='font-size:36px;color:red'><strong>"+"</strong><p>"+HttpErrorResponse.statusText;
      if (HttpErrorResponse.error) message += "<br>" + "<p style='text-align:center'>" + HttpErrorResponse.error.descrMessage + "</p>"

    }
    if (HttpErrorResponse.status == '40991') {
      message = "Autorizzazione Negata (token di accesso non valido)";
      //alert(message,"Errore Accesso");
      this.utenteService.LogOut();
      this.router.navigateByUrl("/", { skipLocationChange: true })
      //this.router.navigateByUrl("/");
    }

    if (HttpErrorResponse.status == '0') {

      console.log("Questo è il messaggio di errore per sessione scaduta ", HttpErrorResponse)
      message = "<p style='font-size:20px;color:red;text-align: center'><strong>Impossibile raggiungere il sito<br>Connessione negata da rentrincloud.it</strong><p>";

      this.utenteService.LogOut();
      this.router.navigate(['/login']).then(() => {
        //location.reload();

      });

      //message="Il Server sembra non disponibile. Riprova";
      //alert(message,"Errore Accesso");
      //this.utenteService.LogOut();
      //this.router.navigateByUrl("/",{skipLocationChange:true})
      //this.router.navigateByUrl("/");
    }

    if (HttpErrorResponse.status == '400') {
      message = ""
      if (HttpErrorResponse.error && HttpErrorResponse.error['odata.error']) {
        message = HttpErrorResponse.error['odata.error'].message.value;
      }

      if (HttpErrorResponse.error) {

        if (HttpErrorResponse.error.traceMessage)
          message += "<p>" + HttpErrorResponse.error.traceMessage + "</p>";

        if (HttpErrorResponse.error.descrMessage && !HttpErrorResponse.error.errors) {
          message += HttpErrorResponse.error.descrMessage;
        } else {
          let value = '<ul>';
          for (let key in HttpErrorResponse.error.errors) {
            //value+="<li> <p><strong>"+key+"</strong>&nbsp"+HttpErrorResponse.error.errors[key]+"</p></li>";
            value += "<li> <p><strong>" + '' + "</strong>&nbsp" + HttpErrorResponse.error.errors[key] + "</p></li>";
          }
          value += '</ul>';
          message += value;
          //if(HttpErrorResponse.error.error) {
          //message=HttpErrorResponse.error.error;      
          //}
        }
      }
    }
    if (HttpErrorResponse.status == '405') {
      message = HttpErrorResponse.message;
    }
    if (HttpErrorResponse.status == '409') {
      //alert("Errore Concorrenza 1","Errore Concorrenza");
    }
    if (HttpErrorResponse.codeMessage === -1) {

      message = HttpErrorResponse.descrMessage;
    }
    //    if(message>"" && this.utenteService.checSessionError==false) alert(message,"Errore");
    if (message > "") alert(message, "Errore");

    if (HttpErrorResponse.status == '401' || HttpErrorResponse.status == '500') {
      this.utenteService.LogOut();
      this.router.navigate(['/login']).then(() => {
        //location.reload();

      });
    } return message;






  }
  //ForcePassword($user,$oldpassword,$newpassword)
  ForcePassword(user, oldpassword, newpassword) {
    var headers = new HttpHeaders();
    //headers.append('Content-Type', 'application/x-www-form-urlencoded;');
    //headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    headers.append('Content-Type', 'text');
    const EndPoint = environment.BASE_API_URL + "Account/ReimpostaPassword"
    const body = { oldPassword: oldpassword, newPassword: newpassword, foceLogOut: true };
    return this.httpClient.post(EndPoint, body, { headers })



      //  const EndPoint=environment.BASE_API_URL+"Account/ReimpostaPassword?oldPassword="+oldpassword+"&newPassword="+newpassword+"&foceLogOut=true"
      //const HeaderOdata=this.httpOptionCall();
      //return this.httpClient.get(EndPoint,HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  async getCausaliByPosizione(value) {
    this.spinner.show();
    let log = await this.GetApi('CausaleRifiuti/GetCausaliRifiutiByPosizione?IdPosizioneRifiuto=' + value);
    this.spinner.hide();
    return log;
  }

  async getExtendMovimenti(url) {
    this.spinner.show();
    let log = await this.GetApi(url);
    this.spinner.hide();
    return log;
  }

  async getPosizioniByCauale(value) {
    this.spinner.show();
    let log = await this.GetApi('PosizioneCausale?idCausale=' + value);
    this.spinner.hide();
    return log;
  }

  async GetExternalApiBackEnd(EndPoint: string) {
    //const EndPoint=environment.BASE_API_URL+api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClientNoInterceptor.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  async GetApiBackEnd(api: string) {
    const EndPoint = environment.BASE_API_URL + api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClientNoInterceptor.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async GetApiRest(api: string) {
    const EndPoint = environment.BASE_API_URL_APIREST + api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async PutApiRest(api: string, data: { [key: string]: any }) {
    const EndPoint = environment.BASE_API_URL_APIREST + api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClient.put(EndPoint, data, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async GetApi(api: string, headers: Record<string, any> = {}) {
    const EndPoint = environment.BASE_API_URL + api;
    const HeaderOdata = this.httpOptionCall();
    Object.entries(headers || {}).forEach(([key, value]) => {
      if (value) HeaderOdata.headers = HeaderOdata.headers.set(key, value);
    });
    return await this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async PutApi(api: string, data: { [key: string]: any }, contentType: 'application/json' | 'application/x-www-form-urlencoded' | 'text/plain' | 'multipart/form-data' = 'application/json') {
    const EndPoint = environment.BASE_API_URL + api;
    var headers = new HttpHeaders();
    headers.append('Content-Type', contentType);
    // const HeaderOdata = this.httpOptionCall();
    return await this.httpClient.put(EndPoint, data, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }
  async PostApi(api: string, value, contentType: 'application/json' | 'application/x-www-form-urlencoded' | 'text/plain' | 'multipart/form-data' = 'application/json') {
    const EndPoint = environment.BASE_API_URL + api
    var headers = new HttpHeaders();
    headers.append('Content-Type', contentType);
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();

  }
  async DeleteApi(api: string) {
    const EndPoint = environment.BASE_API_URL + api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClient.delete(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async DeleteApiRest(api: string) {
    const EndPoint = environment.BASE_API_URL_APIREST + api;
    const HeaderOdata = this.httpOptionCall();
    return await this.httpClient.delete(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  async PostApiRest(api: string, value, contentType: 'application/json' | 'application/x-www-form-urlencoded' | 'text/plain' = 'application/json') {
    const EndPoint = environment.BASE_API_URL_APIREST + api
    var headers = new HttpHeaders();
    headers.append('Content-Type', contentType);
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();

  }

  Logout() {
    const EndPoint = environment.BASE_API_URL + "token/Logout";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();

  }

  GetProvincie() {
    const EndPoint = environment.BASE_API_URL + "Provincia";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  GetAllDb() {
    const EndPoint = environment.BASE_API_URL + "Azienda";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  GetLicenzeByUser(value: string) {
    const EndPoint = environment.BASE_API_URL + "Licenza/GetLicenzeByUser?userId=" + value;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  AttivaLicenza(value: string) {
    const EndPoint = environment.BASE_API_URL + "Licenza/AttivaLicenza?CodiceLicenza=" + value;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  CreaLicenza(obj, codiceAssistenza) {
    const endpoint = `${environment.BASE_API_URL}Licenza?codiceAssistenza=${codiceAssistenza}`;
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.post(endpoint, obj, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }
  AggiornaLicenza(obj, codiceAssistenza) {
    const endpoint = `${environment.BASE_API_URL}Licenza?codiceAssistenza=${codiceAssistenza}`;
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.put(endpoint, obj, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }




  GeneraInviaPin(tipoNotifica) {
    //	tiponotificapin 0=email 1=sms
    let TpN = "SMS";
    if (tipoNotifica == 1) TpN = 'EMAIL';
    const EndPoint = environment.BASE_API_URL + "Account/GeneraPIN?tipoPIN=" + TpN;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }


  //this.appService.removeLicenza(t.currentLicenza.id).then(response=>{
  removeDB(alias: string) {
    //const EndPoint=environment.BASE_API_URL+"Azienda/eliminaDB?id="+alias;
    const EndPoint = environment.BASE_API_URL + "Azienda/" + alias;

    var headers = new HttpHeaders();
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.delete(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  ScriviPermessiGruppo(value) {
    const EndPoint = environment.BASE_API_URL + "Gruppo"
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();

  }

  ScriviPermessiUtente(value) {
    const EndPoint = environment.BASE_API_URL + "AccountPermessi"
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();

  }

  AbilitaDisabilitaLicenza({ CodeLicenza, IsAbilitata }) {
    const EndPoint = environment.BASE_API_URL + "Licenza/AbilitaDisabilitaLicenza?CodeLicenza=" + CodeLicenza + "&IsAbilitata=" + IsAbilitata;
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    return this.httpClient.post(EndPoint, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }


  removeLicenza(alias: string) {
    const EndPoint = environment.BASE_API_URL + "Licenza/eliminaLicenza?licenza=" + alias;
    var headers = new HttpHeaders();
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.delete(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  CreaDB(alias: string, descrizione: string, usernameRentri: string, passwordRentri: string,
    codiceFiscale: string) {
    const value = {
      "descrizione": descrizione,
      "alias": alias,
      "usernameRentri": usernameRentri,
      "passwordRentri": passwordRentri,
      "codiceFiscaleAzienda": codiceFiscale
    }
    const EndPoint = environment.BASE_API_URL + "Azienda";
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }


  CreaOwner(value) {
    const EndPoint = environment.BASE_API_URL + "Account/CreateOwner";
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    const body = value;
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }
  ///Account/ReinviaIscrizione
  ReinviaIscrizione(value) {
    const EndPoint = environment.BASE_API_URL + "Account/ReinviaIscrizione?username=" + value;
    var headers = new HttpHeaders();
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }


  SetDBLavoro(value: number) {
    ///Token/SetLicenzaLavoro
    const EndPoint = environment.BASE_API_URL + "Token/SetAziendaLavoro?idAzienda=" + value;
    var headers = new HttpHeaders();
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }


  SetLicenzaLavoro(value: string) {
    ///Token/SetLicenzaLavoro
    const EndPoint = environment.BASE_API_URL + "Token/SetLicenzaLavoro?idLicenza=" + value;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  getRegistriElenco(idSede: any) {
    const EndPoint = environment.BASE_API_URL + "RentriOld/getRegistriElencoBySede?idSede=" + idSede;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();

  }


  LoginRentriBySede(sede) {
    const EndPoint = environment.BASE_API_URL + "RentriOld/LoginRentriBySede?IdSede=" + sede;
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');
    //const body={};
    return this.httpClient.post(EndPoint, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }


  Login(user, password, licenza, flag) {
    //const EndPoint=environment.BASE_API_URL+"api/elenco/getElencoNSUnitaLocali";
    const EndPoint = environment.BASE_API_URL + "Token/login";
    var headers = new HttpHeaders();
    //headers.append('Content-Type', 'application/x-www-form-urlencoded;');
    //headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    headers.append('Content-Type', 'text');
    const body = {
      Username: user, Password: password, Licenza: licenza,
      forceLogin: (flag) ? flag : false
    };
    return this.httpClient.post(EndPoint, body, { headers })
      .toPromise()
      .then(response => response)
      .catch();
  }
  AccountGetAll() {
    const EndPoint = environment.BASE_API_URL + "Account/GetAll";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  RigeneraIscrizione(user) {
    const EndPoint = environment.BASE_API_URL + "Account/RecuperaPassword?username=" + user;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  RecuperaPassword(user) {
    const EndPoint = environment.BASE_API_URL + "Account/RecuperaPassword?username=" + user;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  checkPin(pinInserito) {
    //const EndPoint=environment.BASE_API_URL+"api/elenco/getElencoNSUnitaLocali";
    ///Account/InviaPIN?PIN=512735
    const EndPoint = environment.BASE_API_URL + "Account/InviaPIN?PIN=" + pinInserito;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  IsValidUser(user) {
    const EndPoint = environment.BASE_API_URL + "Token/IsValidUser?user=" + user;
    //const EndPoint=environment.BASE_API_URL_WEBRIFIUTI+"?azione=cercaUser&user="+user;
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint)
      .toPromise()
      .then(response => response)
      .catch();
  }
  GetUserInfo() {
    const EndPoint = environment.BASE_API_URL + "Account/GetUserInfo";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }
  PutUserInfo(object: any): Promise<any> {
    //const EndPoint=environment.BASE_API_URL+"api/elenco/getElencoNSUnitaLocali";
    //
    console.log("object", object);
    const EndPoint = environment.BASE_API_URL + "account/" + object['id'];
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded;');
    //headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    //headers.append('Content-Type', 'text');      
    //const body=JSON.stringify(object);
    const body = object;
    return this.httpClient.put(EndPoint, body, { headers })
      .toPromise()
  }
  ///Token/isExistsUsers
  isExistsUsers() {
    const EndPoint = environment.BASE_API_URL + "Token/isExistsUsers";
    const HeaderOdata = this.httpOptionCall();
    return this.httpClient.get(EndPoint, HeaderOdata)
      .toPromise()
      .then(response => response)
      .catch();
  }

  invioEmail(data) {



    //const EndPoint=environment.BASE_API_URL+"Token/login";

    const url = environment.BASE_API_URL + "Emails/invio";
    /*
     let httpOptions = {
       headers: new HttpHeaders({
         'Content-Type':  'application/json',
         "Access-Control-Allow-Origin": "*",
         
       } )
     };
   */

    return this.httpClient.post(url, (data as FormData), { responseType: 'text' }) //{headers}
      .toPromise()


  }


}
